import Swiper from 'swiper/swiper-bundle';

export function ourClients() {
  const sectionCasesContainer = document.querySelector('.section-cases');

  if (!sectionCasesContainer) {
    return;
  }

  const cardsElements = sectionCasesContainer.querySelectorAll('.case-item');
  const tabsWrapper = sectionCasesContainer.querySelector('.tabs');
  const tabsElements = sectionCasesContainer.querySelectorAll('.tabs__item');
  const emptyTextElement = sectionCasesContainer.querySelector('.section-cases__empty');
  const buttonLoad = sectionCasesContainer.querySelector('.section-cases__button');
  const TAB_ACTIVE_CLASS = 'active';
  const MAIN_CATEGORY = 'Усі кейси';
  const ITEMS_PER_LOAD = 4;
  let currentIndex = 0;
  let filterElements = cardsElements;

  if (!cardsElements.length) {
    return;
  }

  function changeTab() {
    const currentValue = this.getAttribute('data-value');
    const parentElement = this.closest('.tabs');
    const activeElement = parentElement.querySelector(`.tabs__item.${TAB_ACTIVE_CLASS}`);

    if (this.classList.contains(`${TAB_ACTIVE_CLASS}`)) {
      return;
    }

    activeElement.classList.remove(`${TAB_ACTIVE_CLASS}`);
    this.classList.add(`${TAB_ACTIVE_CLASS}`);

    filterElements = [...cardsElements].filter(el => {
      const mapValue = el.getAttribute('data-category');

      if (currentValue === MAIN_CATEGORY) {
        el.setAttribute('data-load', 'true');
      } else if (currentValue === mapValue) {
        el.setAttribute('data-load', 'true');
      } else {
        el.setAttribute('data-load', 'false');
      }

      return el.getAttribute('data-load') === 'true';
    });

    emptyTextElement.style.display = filterElements.length !== 0 ? 'none' : 'flex';

    resetCards();
  }

  function initTabs(tabsContainer, tabsElements) {
    tabsElements[0].classList.add(`${TAB_ACTIVE_CLASS}`);

    const swiper = new Swiper(tabsContainer, {
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 4,
    });

    tabsElements.forEach(tabElement => {
      tabElement.addEventListener('click', changeTab);
    });
  }

  function hiddenUnnecessaryCards() {
    cardsElements.forEach(el => {
      if (el.getAttribute('data-load') === 'false') {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    });

    filterElements.forEach((el, index) => {
      index >= 4 && (el.style.display = 'none');
    });
  }

  function resetCards() {
    currentIndex = 0;

    hiddenUnnecessaryCards();
    loadMore(filterElements);
  }

  function loadMore(tabsElements) {
    for (let i = 0; i < ITEMS_PER_LOAD && currentIndex < tabsElements.length; i++) {
      tabsElements[currentIndex].style.display = 'block';

      currentIndex++;
    }

    buttonLoad.style.display = currentIndex >= tabsElements.length ? 'none' : 'flex';
  }

  function initLoader() {
    if (tabsWrapper && tabsElements.length) {
      initTabs(tabsWrapper, tabsElements);
    }

    loadMore(filterElements);

    buttonLoad.addEventListener('click', function () {
      loadMore(filterElements);
    });
  }

  initLoader();
}


// WEBPACK FOOTER //
// app/scripts/components/ourClients.js